// extracted by mini-css-extract-plugin
export var audioPlayer = "_sg-0";